import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import MeetingElement from './MeetingElement';
import AddMeetingModal from '../Home/Components/AddMeetingModal';
import MeetingReportModal from './MeetingReportModal';
import api from '../api/api';

const MeetingsList = () => {
  const [searchParams] = useSearchParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingMeeting, setEditingMeeting] = useState(null);
  const [meetings, setMeetings] = useState([]);
  const [isReportOpen, setIsReportOpen] = useState(false);
  const [selectedMeeting, setSelectedMeeting] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMeetings = async () => {
    try {
      const res = await api.get('/meetings/');
      setMeetings(res.data);
    } catch (error) {
      console.error('Error fetching meetings:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMeetings();
  }, []);

  const statusFilter = searchParams.get('status');
  const filtered = statusFilter ? meetings.filter(m => m.type === statusFilter) : meetings;

  const handleEditClick = (meeting) => {
    setEditingMeeting(meeting);
    setIsModalOpen(true);
  };

  const handleSave = async (data) => {
    try {
      if (data.id) {
        await api.put(`/meetings/${data.id}/`, data);
      } else {
        await api.post('/meetings/', data);
      }
      fetchMeetings();
      setIsModalOpen(false);
      setEditingMeeting(null);
    } catch (error) {
      console.error('Error saving meeting:', error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('آیا از حذف این جلسه مطمئن هستید؟')) {
      try {
        await api.delete(`/meetings/${id}/`);
        fetchMeetings();
      } catch (error) {
        console.error('Error deleting meeting:', error);
      }
    }
  };

  if (loading) return <div className="p-8 text-center">در حال بارگذاری...</div>;

  return (
    <div className="p-6 bg-slate-50 min-h-screen" dir="rtl">
      <h2 className="text-xl font-bold text-slate-800 mb-6">
        لیست {statusFilter || "همه جلسات"}
      </h2>

      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
        <table className="w-full">
          <thead>
            <tr className="bg-slate-50 border-b border-slate-200 text-slate-500 text-sm">
              <th className="p-4">ساعت</th>
              <th className="p-4">تاریخ</th>
              <th className="p-4 text-right">عنوان جلسه</th>
              <th className="p-4 text-right">توضیحات</th>
              <th className="p-4">عملیات</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((meeting) => (
              <MeetingElement 
                key={meeting.id} 
                {...meeting}
                onEdit={meeting.can_edit ? () => handleEditClick(meeting) : undefined}
                onReport={() => { setSelectedMeeting(meeting); setIsReportOpen(true); }}
                onDelete={meeting.can_edit ? () => handleDelete(meeting.id) : undefined}
              />
            ))}
          </tbody>
        </table>
        <MeetingReportModal 
          isOpen={isReportOpen} 
          onClose={() => setIsReportOpen(false)} 
          meeting={selectedMeeting} 
        />
      </div>

      {isModalOpen && (
        <AddMeetingModal 
          isOpen={isModalOpen}
          onClose={() => { setIsModalOpen(false); setEditingMeeting(null); }}
          initialData={editingMeeting}
          onAdd={handleSave}
        />
      )}
    </div>
  );
};

export default MeetingsList;